import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SessionGuard } from './core/guards/session.guard';
import { SubscriptionResolver } from './core/subscription/subscription.resolver';
import { AgentResolver } from './core/agent/agent.resolver';
import { BannedComponent } from './shared/banned/banned.component';
import { RedirectGuard } from './onboarding/redirect.guard';
import { InitialRedirectGuard } from './core/guards/initial-redirect.guard';
import { CallsRedirectGuard } from './core/guards/calls-redirect.guard';
import { AppRedirectComponent } from './shared/app-redirect/app-redirect.component';
import { AppEmailVerifyComponent } from './shared/app-email-verify/app-email-verify.component';

const routes: Routes = [
  {
    path: '', canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        resolve: {
          subscription: SubscriptionResolver,
          agent: AgentResolver,
        },
        component: DashboardComponent,
        children: [
          { path: '', canActivate: [InitialRedirectGuard], children: [] },
          { path: 'setup', loadChildren: () => import('./guided-setup/guided-setup.module').then(m => m.GuidedSetupModule) },
          { path: 'conversations', loadChildren: () => import('./conversations/conversations.module').then(m => m.ConversationsModule) },
          { path: 'calls', canActivate: [CallsRedirectGuard], children: [] }, // Backwards compatibility - preserves params
          { path: 'integrations', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule) },
          { path: 'settings', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule) },
          { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
        ]
      }
    ]
  },
  { path: 'oops', component: BannedComponent },
  { path: 'download', component: AppRedirectComponent },
  // Public bridge for mobile email verification: the email links here over https
  // (clickable), and this page hands off to the rosie:// app deep link.
  { path: 'app-verify-email', component: AppEmailVerifyComponent },
  {
    path: 'register/agent',
    canActivate: [RedirectGuard],
    component: DashboardComponent,

  },
  {
    path: 'register/preview',
    canActivate: [RedirectGuard],
    component: DashboardComponent,

  },
  {
    path: 'register/user',
    canActivate: [RedirectGuard],
    component: DashboardComponent,
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule), canActivate: [SessionGuard] },
  // Public like /register: Variant B collects the card here before any business
  // exists, so it must not run AuthenticationGuard (which needs a business). It's
  // gated at the API layer instead — the card endpoints are auth:sanctum.
  { path: 'complete-signup', loadChildren: () => import('./complete-signup/complete-signup.module').then(m => m.CompleteSignupModule) },
  { path: 'register', loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule) },
  { path: 'invitations/accept/:token', loadChildren: () => import('./business-invitation/business-invitation.module').then(m => m.BusinessInvitationModule) },
  { path: 'forgot-password', loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  {
    path: 'password-reset', loadChildren: () => import('./password-update/password-update.module').then(m => m.PasswordUpdateModule),
  },
  // Public: HubSpot Marketplace installs open this page in a popup. It signs the
  // user in itself, so AuthenticationGuard and /login are deliberately not involved.
  { path: 'hubspot-install', loadComponent: () => import('./hubspot-install/hubspot-install.component').then(m => m.HubspotInstallComponent) },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AdminRoutingModule {
}
